import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import Moment from 'react-moment';
import { Modal } from 'react-bootstrap';
import { getEmployeeDetailsByIdData } from '../../../store/actions/EmployeeActions';

function RightSideModal({ showModal, setShowModal, userId }) {
    const dispatch = useDispatch();
    const [details, setDetails] = useState(null);

    useEffect(() => {
        if (userId) {
            dispatch(getEmployeeDetailsByIdData(userId, updateCallBack));
        }
    }, [showModal, userId]);

    const updateCallBack = (data) => {
        setDetails(data);
    }

    return (
        <Modal
            className="right-modal"
            show={showModal}
            onHide={() => setShowModal(false)}
            backdrop="static"
            keyboard={false}
        >
            <div className="comment-modal-container">
                <div className="modal-header pe-2 ps-2">
                    <h4 className="modal-title">Person Details</h4>
                    <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                </div>
                <div className="modal-body pe-2 ps-2">
                    <div>
                        <label className='mb-2'><strong>Full Name:</strong> {details?.first_name} {details?.last_name}</label>
                    </div>
                    <div>
                        <label className='mb-2'><strong>Email:</strong> {details?.email}</label>
                    </div>
                    <div>
                        <label className='mb-2'><strong>Phone No:</strong> {details?.country_code} {details?.phone_no}</label>
                    </div>
                    {details?.country && (
                        <div>
                            <label className='mb-2'><strong>Country:</strong> {details?.country}</label>
                        </div>)}
                    <div>
                        <label className='mb-2'><strong>Created Date:</strong> <Moment format="D MMM YYYY" withTitle>{details?.created_at}</Moment></label>
                    </div>
                    {/* <div>
                        <label className='mb-2'><strong>Full Name:</strong> {details?.first_name} {details?.last_name}</label>
                    </div> */}
                </div>
            </div>
        </Modal>
    );
}
export default RightSideModal;